// extracted by mini-css-extract-plugin
module.exports = {"table_wrapper":"Table_table_wrapper__fuKj6","table":"Table_table__d_fUq"};